import { getEncryptDataFromPath } from "../utils"

export const URL_TYPE = {
  OPEN_IN_WEB_VIEWER: 0,
  SHAREABLE_LINK: 1
}

export const getUrlType = () => {
  const { userId, path, downloadUrl } = getEncryptDataFromPath()

  if(userId && path) {
    return URL_TYPE.OPEN_IN_WEB_VIEWER
  }

  if(downloadUrl) {
    return URL_TYPE.SHAREABLE_LINK
  }
}